import { render, staticRenderFns } from "./import-validation-data-table.vue?vue&type=template&id=4fd981aa&scoped=true"
import script from "./import-validation-data-table.vue?vue&type=script&lang=js"
export * from "./import-validation-data-table.vue?vue&type=script&lang=js"
import style0 from "./import-validation-data-table.vue?vue&type=style&index=0&id=4fd981aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd981aa",
  null
  
)

export default component.exports